"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const CellDisplayList = ({ items, onAddToListClicked, onRemoveFromListClicked, readOnly }) => (react_1.default.createElement("div", { className: 'cell-display-list' },
    items.map((writer) => (react_1.default.createElement("div", { className: 'list-item', key: writer.ipId },
        react_1.default.createElement("span", null,
            writer.firstName,
            " ",
            writer.lastName),
        onRemoveFromListClicked && !readOnly && (react_1.default.createElement("button", { className: 'remove-from-list-button', onClick: () => onRemoveFromListClicked(writer) },
            react_1.default.createElement("img", { src: common_1.ICONS.close, alt: "remove-from-list-button" })))))),
    onAddToListClicked && (react_1.default.createElement(Button_1.Button, { disabled: readOnly, mainColor: true, type: 'primary', onClick: onAddToListClicked }, "Link Writer"))));
exports.default = CellDisplayList;
